import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  List, 
  ListItem, 
  ListItemText, 
  ListItemButton, 
  ListItemIcon,
  Avatar,
  Divider,
  IconButton,
  Typography,
  Box
} from '@mui/material';
import { PlaceOutlined, Close, Room } from '@mui/icons-material';
import { useSelector, useDispatch } from 'react-redux';
import { setLocation } from '../../store/location';
import { primarycolor } from '../Utils/colors';

const LocationModal = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const webSettings = useSelector((state) => state.webSettings.data);
  const currentLocation = useSelector((state) => state.location.data);
  const locations = webSettings?.locations || [];

  const handleSelect = (loc) => {
    dispatch(setLocation(loc));
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        style: {
          borderRadius: 20,
          padding: 8
        }
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <PlaceOutlined color="primary" />
          <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Select Branch</Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      
      <Box sx={{ px: 2, pb: 2 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'medium', textTransform: 'uppercase', letterSpacing: 1 }}>
          Current Delivery Shop
        </Typography>
      </Box>

      <List sx={{ pt: 0, pb: 2 }}>
        {locations.map((loc) => (
          <React.Fragment key={loc.mainLocation}>
            <ListItem disableGutters>
              <ListItemButton 
                onClick={() => handleSelect(loc)}
                selected={currentLocation?.mainLocation === loc.mainLocation}
                sx={{ 
                  borderRadius: 2,
                  mx: 1,
                  '&.Mui-selected': {
                    backgroundColor: `${primarycolor}10`,
                    '&:hover': {
                      backgroundColor: `${primarycolor}20`,
                    }
                  }
                }}
              >
                <ListItemIcon>
                  <Avatar sx={{ 
                    bgcolor: currentLocation?.mainLocation === loc.mainLocation ? primarycolor : '#f1f1f2',
                    width: 36,
                    height: 36
                  }}>
                    <Room sx={{ fontSize: 20, color: currentLocation?.mainLocation === loc.mainLocation ? '#white' : '#757575' }} />
                  </Avatar>
                </ListItemIcon>
                <ListItemText 
                  primary={loc.locationName} 
                  primaryTypographyProps={{ 
                    fontWeight: currentLocation?.mainLocation === loc.mainLocation ? 'bold' : 'medium',
                    color: currentLocation?.mainLocation === loc.mainLocation ? 'primary' : 'text.primary'
                  }}
                  secondary={currentLocation?.mainLocation === loc.mainLocation ? 'Currently Selected' : null}
                />
              </ListItemButton>
            </ListItem>
            <Divider variant="inset" component="li" sx={{ opacity: 0.5, ml: 9 }} />
          </React.Fragment>
        ))}
      </List>
      
      {locations.length === 0 && (
        <Box sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">No locations available</Typography>
        </Box>
      )}
    </Dialog>
  );
};

export default LocationModal;
